var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-box"},[_c('div',{staticClass:"contanir flex-c"},[_c('div',[_vm._v("版权所有：济南市长清区邦客堂教育培训学校有限公司")]),_c('div',{staticClass:"m-l-20"},[_vm._v("备案号："),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/#/Integrated/index"}},[_vm._v("鲁ICP备2024132430号")])])])])
}]

export { render, staticRenderFns }